module.exports = __webpack_public_path__ + "img/marionnaud.d541ea79.jpg";